import { MainViewLayout } from "@/components/layouts/MainViewLayout";
import { InlineError } from "@/components/ui/InlineError";

const reload = () => window.location.reload();

/**
 * Shown by the router in place of a route that threw while rendering (for example on a response
 * shaped differently than the view expects), instead of React Router's bare default page.
 * Inside the admin app it fills only the content area, so the sidebar still navigates away.
 */
export const RouteErrorView = ({ insideApp = false }: { insideApp?: boolean }) => {
  const message = (
    <>
      This page ran into an unexpected error and could not be shown. Retry reloads it; if the error
      comes back, contact SkillPanel support.
    </>
  );

  if (insideApp) {
    return (
      <MainViewLayout>
        <div className="flex w-full max-w-4xl flex-col gap-4 xl:gap-6">
          <MainViewLayout.ViewTitle>Something went wrong</MainViewLayout.ViewTitle>
          <InlineError onRetry={reload}>{message}</InlineError>
        </div>
      </MainViewLayout>
    );
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="flex w-full max-w-xl flex-col gap-4">
        <h1 className="text-2xl font-medium text-foreground">Something went wrong</h1>
        <InlineError onRetry={reload}>{message}</InlineError>
      </div>
    </main>
  );
};
